import { j as a } from "../../../_virtual/jsx-runtime.js";
import r from "../../atoms/Indicator/index.js";
const s = 6, i = 5, d = Array.from(
  { length: i },
  (t, e) => ({ id: e.toString() })
), c = Array.from({ length: s }, (t, e) => ({
  accessorKey: `col-${e}`,
  header: () => /* @__PURE__ */ a.jsx("div", { className: "relative mb-4", children: /* @__PURE__ */ a.jsx(r, { isLoading: !0 }) }, e),
  cell: ({ row: o }) => /* @__PURE__ */ a.jsx("div", { className: "relative", children: /* @__PURE__ */ a.jsx(r, { isLoading: !0, children: " " }) }, `${o.getValue("id")}-${e}`)
}));
export {
  c as defaultLoadingTableColumns,
  d as defaultLoadingTableData
};
